module.exports = __webpack_public_path__ + "static/media/bg-no-coins.9f7e98dc.png";